import { $Q, $Qll } from '../utils/query-selector';
import { addProducts } from './cart';

export function validationBtn() {
  const btnProduct = $Q('.new-form-atc.addCart');

  if (btnProduct) {
    btnProduct.classList.add('hidden')
    const newbtn = btnProduct.cloneNode(true);
    newbtn.classList.remove('hidden')
    btnProduct.parentNode.insertBefore(newbtn, btnProduct)

    newbtn.addEventListener('click', () => {
      const dataId = $Q('.new-form-option.selectedWB').dataset.id
      const form = $Q('[data-type="add-to-cart-form"]')

      $Q('input[name="id"]', form).value = dataId

      addProducts(form);
    })
  }
}
